import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Button, Card, Col, Container, Fa, Nav, NavItem, Row} from "mdbreact";
import { NavLink} from "react-router-dom";
import validator from 'validator';
import axios from "axios";
import axiosRetry from 'axios-retry';
import {LangValidation} from "./../../lang/fa/validation";

import {Alert} from "reactstrap";
import {setUser} from "./../../redux/actions/user";
import {API_URL} from "./../../config/Config";
import SaveLoader from "../../components/loader/SaveLoader";

axiosRetry(axios, { retries: 3 });


class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItemPills: '1',
            fields: {
                firstname: '',
                lastname: '',
                email: '',
                password: '',
                re_password: '',
                cell_phone: '',
                city_id: 1,
                reagent:''
            },
            errors: {},
            hasAlert:false,
            loading:true,
            apiError:"اطلاعات وارد شده صحیح نمی باشد."
        };

    }

     handleValidation(callback) {
        let {fields} = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.firstname)) {
             formIsValid = false;
             errors["firstname"] = LangValidation.required;
         }else if (!validator.isLength(fields.firstname, {min: 3, max: undefined})) {
             formIsValid = false;
             errors["firstname"] = LangValidation.min;
         }

         if (validator.isEmpty(fields.lastname)) {
             formIsValid = false;
             errors["lastname"] = LangValidation.required;
         }else if (!validator.isLength(fields.lastname, {min: 3, max: undefined})) {
             formIsValid = false;
             errors["lastname"] = LangValidation.min;
         }

         if (validator.isEmpty(fields.email)) {
             formIsValid = false;
             errors["email"] = LangValidation.required;
         }else if (!validator.isEmail(fields.email)) {
             formIsValid = false;
             errors["email"] = LangValidation.email;
         }

         if (validator.isEmpty(fields.password)) {
             formIsValid = false;
             errors["password"] = LangValidation.required;
         }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
             formIsValid = false;
             errors["password"] = LangValidation.min;
         }

         if (validator.isEmpty(fields.re_password)) {
             formIsValid = false;
             errors["re_password"] = LangValidation.required;
         }else if (fields.re_password !== fields.password) {
             formIsValid = false;
             errors["re_password"] = LangValidation.same;
         }

         if (validator.isEmpty(fields.cell_phone)) {
             formIsValid = false;
             errors["cell_phone"] = LangValidation.required;
         }else if (!validator.isNumeric(fields.cell_phone)) {
             formIsValid = false;
             errors["cell_phone"] = LangValidation.numeric;
         }

        this.setState({errors}, () => {
            return callback(formIsValid)
        });
    }

     handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

       switch (target.name) {
           case 'firstname':
               if (validator.isEmpty(fields.firstname)) {
                   errors["firstname"] = LangValidation.required;
               }else if (!validator.isLength(fields.firstname, {min: 3, max: undefined})) {
                   errors["firstname"] = LangValidation.min;
               }
               break;
           case 'lastname':
               if (validator.isEmpty(fields.lastname)) {
                   errors["lastname"] = LangValidation.required;
               }else if (!validator.isLength(fields.lastname, {min: 3, max: undefined})) {
                   errors["lastname"] = LangValidation.min;
               }
               break;
           case 'email':
               if (validator.isEmpty(fields.email)) {
                   errors["email"] = LangValidation.required;
               }else if (!validator.isEmail(fields.email)) {
                   errors["email"] = LangValidation.email;
               }
               break;
           case 'password':
               if (validator.isEmpty(fields.password)) {
                   errors["password"] = LangValidation.required;
               }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
                   errors["password"] = LangValidation.min;
               }
               break;
           case 're_password':
               if (validator.isEmpty(fields.re_password)) {
                   errors["re_password"] = LangValidation.required;
               }else if (fields.re_password !== fields.password) {
                   errors["re_password"] = LangValidation.same;
               }
               break;
           case 'cell_phone':
               if (validator.isEmpty(fields.cell_phone)) {
                   errors["cell_phone"] = LangValidation.required;
               }else if (!validator.isNumeric(fields.cell_phone)) {
                   errors["cell_phone"] = LangValidation.numeric;
               }
               break;

           default:

        }
        this.setState({
            fields,errors
        });

       }

    checkStatus(response) {
        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
        return response.data;
    }

    async handleRequest() {
        const {firstname, lastname, email, password, cell_phone, city_id, reagent} = this.state.fields;
        const formData = {firstname, lastname, email, password, cell_phone, city_id, reagent};
        let errors = {};
        this.setState({loading: false});

        try {
            let response = await axios.post(`${API_URL}register`,formData);
            let user = await response.data.data;
            this.props.setUser(user);
            this.props.history.push('/users');

        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                let status = await apiError.status;
                let data = await apiError.data;
                let apiErrorText = await data.data;
                this.setState({apiErrorText});
                console.log(statusText);
                if (status ===422){
                    for (let key in data) {
                        if (data.hasOwnProperty(key)) {
                            errors[key] = data[key];
                        }
                    }
                    this.setState({errors});
                }
            }
            this.setState({hasAlert:true});
        }
        this.setState({loading: true});
    }

    handleRegister(event) {
        event.preventDefault();
       this.handleValidation((valid) => {
            if (valid) this.handleRequest();
        });
    }

    render() {
        const {firstname, lastname, email, password, re_password, cell_phone, reagent} = this.state.fields;
        const {errors} = this.state;


        return (
            <div className="pt-5">
                <Container className="pt-5">
             {/*       <Breadcrumb className='w-100 white mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem active> ورود کاربر</BreadcrumbItem>
                    </Breadcrumb>*/}
                    <div className="container rtl login-container" >
                        <div className="row">
                            <div className="col-md-8 " style={{float: "none", margin: "0 auto"}}>
                                <Card style={{padding:20}}>

                                    <div className="card-header1 mb-2">
                                        <Nav pills color="secondary" className="nav-justified mt-2">
                                            <NavItem>
                                                <NavLink to="/login" className="btn btn-link">
                                                    ورود کاربر
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <Button color="deep-orange"  to="/register" className="btn btn-default btn-block">
                                                    ثبت نام در سامانه
                                                </Button>
                                            </NavItem>
                                        </Nav>
                                        <hr/>
                                            <Row>
                                                <Col md="12">
                                                    {this.state.hasAlert? <Alert color="danger">{this.state.apiError}</Alert> :""}
                                                </Col>
                                            </Row>
                                        <form>
                                            <Row>
                                                <Col md="6" sm="12">
                                                    <div className="md-form input-group" error="true" >
                                                        <span className="input-group-addon p-2">
                                                            <i className="fa fa-user grey-text mt-3" style={{fontSize: 20}}/>
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className={errors["firstname"]?"form-control is-invalid":"form-control"}
                                                            placeholder="نام"
                                                            autoComplete="off"
                                                            name="firstname"
                                                            value={firstname}
                                                            onChange={this.handleChange.bind(this)}
                                                        />
                                                        {errors["firstname"]?<div className="invalid-feedback" >{errors["firstname"]}</div>:""}
                                                    </div>
                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-user grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="text"
                                                               placeholder="نام خانوادگی"
                                                               className={errors["lastname"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="lastname"
                                                               value={lastname}
                                                               onChange={this.handleChange.bind(this)}
                                                            />
                                                        {errors["lastname"]?<div className="invalid-feedback" >{errors["lastname"]}</div>:""}
                                                    </div>
                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-envelope grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="email"
                                                               placeholder="ایمیل"
                                                               className={errors["email"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="email"
                                                               value={email}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["email"]?<div className="invalid-feedback" >{errors["email"]}</div>:""}

                                                    </div>

                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-phone grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="text"
                                                               placeholder="موبایل"
                                                               className={errors["cell_phone"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="cell_phone"
                                                               value={cell_phone}
                                                               onChange={this.handleChange.bind(this)}/>

                                                        {errors["cell_phone"]?<div className="invalid-feedback" >{errors["cell_phone"]}</div>:""}

                                                    </div>

                                                </Col>
                                                <Col md="6" sm="12">

                                                    <div className="md-form input-group">
                                                        <span className="input-group-addon p-2">
                                                            <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                                        </span>
                                                            <input type="password"
                                                                   placeholder="رمز عبور"
                                                                   className={errors["password"]?"form-control is-invalid":"form-control"}
                                                                   autoComplete="off"
                                                                   name="password"
                                                                   value={password}
                                                                   onChange={this.handleChange.bind(this)}/>
                                                            {errors["password"]?<div className="invalid-feedback" >{errors["password"]}</div>:""}

                                                    </div>
                                                    <div className="md-form input-group">
                                                        <span className="input-group-addon p-2">
                                                            <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                                        </span>
                                                        <input type="password"
                                                               placeholder="تکرار رمز عبور"
                                                               className={errors["re_password"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="re_password"
                                                               value={re_password}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["re_password"]?<div className="invalid-feedback" >{errors["re_password"]}</div>:""}

                                                    </div>
                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-random grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="text"
                                                               className="form-control"
                                                               placeholder="کد معرف"
                                                               autoComplete="off"
                                                               name="reagent"
                                                               value={reagent}
                                                               onChange={this.handleChange.bind(this)}/>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div className="text-center mt-5">
                                                        <Button color="deep-orange"  block onClick={this.handleRegister.bind(this)} className="mb-4 mt-4">
                                                            ثبت <Fa icon="paper-plane-o white-text" className="ml-1"/>
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                </Container>
                {!this.state.loading ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight}/>:""}
                </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser : user => {
            dispatch(setUser(user))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Register);



// WEBPACK FOOTER //
// ./src/containers/auth/Register.js